import { ECardType } from '__generated__/globalTypes';
import { ICardView } from 'libs/types/card/cardTypes';
import { Localization } from 'static/localization/localization';

export const useAddCard = () => {
    const cards: ICardView[] = [
        {
            iconSet: 'fal',
            iconName: 'font',
            title: Localization.TEXT,
            cardType: ECardType.TEXT
        },
        {
            iconSet: 'fal',
            iconName: 'image-polaroid',
            title: Localization.IMAGE,
            cardType: ECardType.IMAGE
        },
        {
            iconSet: 'fal',
            iconName: 'link',
            title: Localization.LINK,
            cardType: ECardType.LINK
        }
        // {
        //     iconSet: 'fab',
        //     iconName: 'instagram',
        //     title: 'Instagram',
        //     cardType: ECardType.INSTAGRAM
        // },
        // {
        //     iconSet: 'fab',
        //     iconName: 'youtube',
        //     title: 'Youtube',
        //     cardType: ECardType.VIDEO
        // },
        // {
        //     iconSet: 'fab',
        //     iconName: 'facebook',
        //     title: 'Facebook',
        //     cardType: ECardType.FACEBOOK
        // },
        // {
        //     iconSet: 'fal',
        //     iconName: 'list',
        //     title: 'Linked details',
        //     cardType: ECardType.LINKEDSTORIES
        // },
        // {
        //     iconSet: 'fab',
        //     iconName: 'twitter',
        //     title: 'Twitter',
        //     cardType: ECardType.TWITTER
        // },
        // {
        //     iconSet: 'fal',
        //     iconName: 'alien-8bit',
        //     title: 'GIF',
        //     cardType: ECardType.GIF
        // }
    ];

    return {
        cards
    };
};
